<template>
  <div class="wrapper">
    <div class="container">
    <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formData.title"
            :label="'*' + $t('happinessTips.label.table.title')"
            :rules="titleRules"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            :counter="50"
            :maxlength="50"
            class="linea-inferior-pura"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="formData.happinessCategoryTipsId"
            :label="'*' + $t('happinessTips.label.table.category')"
            :items="categories"
            item-text="happinessCategoryTipsName"
            item-value="happinessCategoryTipsId"
            :rules="categoryRules"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            disabled
            class="linea-inferior-pura"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <div class="add-image">
            <span class="text-image">{{ $t('happinessTips.label.form.miniature') }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                  <label for="miniature-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>{{ $t('label.image.text') }}</span>
              <input type="file" @change="onMiniatureChange" id="miniature-input" accept="image/png, image/jpeg, image/webp" style="display: none" />
            </v-tooltip>
            </div>
          <div v-if="formData.miniature" class="image-preview">
            <img v-if="allowedImageTypes.includes(formData.miniature.type)" :src="generateImageUrlPreview(formData.miniature)" alt="Miniatura" />
            <img v-else :src="formData.miniature" alt="Miniatura" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <div class="add-image">
            <span class="text-image">{{ $t('happinessTips.label.form.detail') }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                  <label for="detail-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>{{ $t('label.image.text') }}</span>
              <input type="file" @change="onDetailChange" id="detail-input" accept="image/png, image/jpeg, image/webp" style="display: none" />
            </v-tooltip>
          </div>
          <div v-if="formData.detail" class="image-preview">
            <img v-if="allowedImageTypes.includes(formData.detail.type)" :src="generateImageUrlPreview(formData.detail)" alt="Detalle" />
            <img v-else :src="formData.detail" alt="Detalle" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-file-input
            v-model="formData.fileLink"
            :label="'*' + $t('happinessTips.label.form.fileLink')"
            accept="application/pdf"
            :rules="fileLinkRules"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            class="linea-inferior-pura"
            @change="onFileLinkChange"
          ></v-file-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="formData.active"
            :label="$t('tips.label.table.status')"
            :items="listStatus"
            item-text="nameStatus"
            item-value="valueStatus"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            class="linea-inferior-pura"
          ></v-select>
        </v-col>
      </v-row>


    </v-form>
  </div>
  <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="submitForm"
        >
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.save') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  TIPS_M,
  GET_TIPS as GET_CATEGORIES,
  ACTION_GET_TIPS as ACTION_GET_CATEGORIES,
} from "@/views/tips-categories/store/types/types.js";
import {
  HAPPINESS_TIPS_M,
  GET_HAPPINESS_TIPS,
  ACTION_POST_CREATE_HAPPINESS_TIPS,
} from "@/views/happiness-tips/store/types/types.js";

export default {
  name: "formAddHappinessTipsContentComponent",
  props: {
    category: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      valid: false,
      formData: {
        title: "",
        message: "",
        happinessCategoryTipsId: null,
        miniature: null,
        detail: null,
        fileLink: null,
        active: true,
      },
      listStatus: [
        {
          idStatus: 1,
          nameStatus: 'Visible',
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: 'Oculto',
          valueStatus: false
        }
      ],
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
        "image/svg+xml",
      ],
      titleRules: [
        (v) => !!v || i18n.t('happinessTips.label.form.titleRequired'),
        (v) => (v && v.length <= 50) || i18n.t('happinessTips.label.form.titleMaxLength'),
        (v) => !this.happinessTips.some(t => t.title && t.title.toLowerCase() === v.toLowerCase()) || i18n.t('happinessTips.label.form.titleDuplicate'),
      ],
      categoryRules: [
        (v) => !!v || i18n.t('happinessTips.label.form.categoryRequired'),
      ],
      miniatureRules: [
        (v) => !!v || i18n.t('mindset.label.imageMindset.required'),
      ],
      detailRules: [
        (v) => !!v || i18n.t('mindset.label.imageMindset.required'),
      ],
      fileLinkRules: [
        (v) => !!v || i18n.t('happinessTips.label.form.fileLinkRequired'),
      ],
    };
  },
  watch: {
    category(newVal) {
      if (newVal && newVal.happinessCategoryTipsId) {
        this.formData.happinessCategoryTipsId = newVal.happinessCategoryTipsId;
      }
    }
  },
  computed: {
    ...mapGetters({
      categories: [`${TIPS_M}${GET_CATEGORIES}`],
      happinessTips: `${HAPPINESS_TIPS_M}${GET_HAPPINESS_TIPS}`,
    }),
  },
  methods: {
    ...mapActions({
      postActionHappinessTips: `${HAPPINESS_TIPS_M}${ACTION_POST_CREATE_HAPPINESS_TIPS}`,
      getActionCategories: `${TIPS_M}${ACTION_GET_CATEGORIES}`,
    }),

    onMiniatureChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { maxSize: maxFileSizeMB })
        });
        return;
      }

const img = new Image();
img.src = URL.createObjectURL(file);
img.onload = () => {
  URL.revokeObjectURL(img.src);
  const width = img.width;
  const height = img.height;

  if (width !== height) {
    Swal.fire({
      icon: 'error',
      title: i18n.t('label.errorsValidation.singular.title'),
      text: i18n.t('label.errorsValidation.squareimage.text', { w: width, h: height })
    });
    event.target.value = '';
    return;
  }
        this.formData.miniature = file;
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imageerror.text'),
        });
      };
    },
    onDetailChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { max: maxFileSizeMB })
        });
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(img.src);
        const width = img.width;
        const height = img.height;

    if (height <= width) {
    Swal.fire({
        icon: 'error',
        title: i18n.t('label.errorsValidation.singular.title'),
        text: i18n.t('label.errorsValidation.verticalimage.text', { w: width, h: height })
    });
    event.target.value = '';
    return;
    }

    this.formData.detail = file;
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imageerror.text'),
        });
      };
    },
    onFileLinkChange(file) {
      if (!file) return;
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorFormatFile'),
        }).then(() => {
          this.formData.fileLink = null;
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
          });
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { max: maxFileSizeMB })
        }).then(() => {
          this.formData.fileLink = null;
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
          });
        });
        return;
      }
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    async submitForm() {
      try {
        const result = await Swal.fire({
          title: i18n.t('label.confirm.title'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: i18n.t('button.save.text'),
          cancelButtonText: i18n.t('button.cancel.text'),
          confirmButtonColor: '#6E17A5'
        });
        if (result.isConfirmed) {
          if (this.$refs.form.validate()) {
            const validationErrors = this.validateForm();
            if (Object.keys(validationErrors).length > 0) {
              const errorMessages = Object.values(validationErrors).join('<br>');
              Swal.fire({
                icon: 'error',
                title: i18n.t('label.errorsValidation.plural.title'),
                html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                confirmButtonColor: '#6E17A5'
              });
              return;
            }

            const save = await this.postActionHappinessTips(this.formData);
            if (!save) {
              return Swal.fire({
                icon: 'error',
                title: i18n.t('label.invalid.title'),
                text: i18n.t('label.invalid.text')
              });
            }
            await Swal.fire({
              position: "top-end",
              icon: "success",
              title: i18n.t('happinessTips.actionPostCreateHappinessTips.success'),
              showConfirmButton: false,
              timer: 2500,
            });
            this.$refs.form.reset();
            EventBus.$emit('formHappinessTips-submitted-successfully');
          }
        } else {
          await Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
        }
      } catch (error) {
        console.error(i18n.t('label.failService'));
      }
    },

    validateForm() {
      const errors = {};
      if (!this.formData.title || !this.formData.title.trim() || this.formData.title.length > 100) {
        errors.title = this.$t('happinessTips.label.table.title');
      }
      if (!this.formData.happinessCategoryTipsId) {
        errors.happinessCategoryTipsId = this.$t('happinessTips.label.table.category');
      }
      if (!this.formData.miniature) {
        errors.miniature = this.$t('happinessTips.label.form.miniature');
      }
      if (!this.formData.detail) {
        errors.detail = this.$t('happinessTips.label.form.detail');
      }
      if (!this.formData.fileLink) {
        errors.fileLink = this.$t('happinessTips.label.form.fileLink');
      }
      return errors;
    },
  },
  async mounted() {
    await this.getActionCategories();
    this.$nextTick(() => {
      if (this.category && this.category.happinessCategoryTipsId) {
        this.formData.happinessCategoryTipsId = this.category.happinessCategoryTipsId;
      }
    });
    EventBus.$on('clear-happiness-tips-form', () => {
      this.$refs.form.reset();
      if (this.category && this.category.happinessCategoryTipsId) {
        this.formData.happinessCategoryTipsId = this.category.happinessCategoryTipsId;
      }
    });
  },
};
</script>

<style lang="css" scoped>
.wrapper {
  min-height: 100vh;
  width: 100%;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.add-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.text-image {
  color: #ff7900;
  margin-bottom: 10px;
}

.image-preview {
  margin-top: 10px;
  text-align: center;
}

.image-preview img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  object-fit: cover;
}

.linea-inferior-pura ::v-deep fieldset {
  display: none !important;
  border: none !important;
}

.linea-inferior-pura ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.linea-inferior-pura.v-input--is-focused ::v-deep .v-input__slot {
  border-bottom: 2px solid #6e17a5 !important;
}
</style>
